import create from "zustand";

import { ViewType } from "../components/MarginAccountDetailsTabs/RequirementsAndActivityTab/utils/requirementsSchema";
import { getApiFormattedDate } from "../utils/dateFormatter";

type AccountLookupState = {
  accountErrorMessage: string;
  accountNumber: string;
  toProcessDate: string;
  fromProcessDate: string;
  view: ViewType;
  clearAccountLookupStore: () => void;
  setAccountNumber: (accountNumber?: string) => void;
  setErrorMessage: (errorMessage?: string) => void;
  setDates: (fromProcessDate: string, toProcessDate: string) => void;
  setView: (view: ViewType) => void;
};

const initialState = {
  accountErrorMessage: "",
  accountNumber: "",
  toProcessDate: "",
  fromProcessDate: "",
  view: "detials" as ViewType,
};

export const useAccountLookupStore = create<AccountLookupState>(set => ({
  ...initialState,
  clearAccountLookupStore: () => set(initialState),
  setAccountNumber: accountNumber =>
    set({ accountNumber, accountErrorMessage: "" }),
  setErrorMessage: accountErrorMessage => set({ accountErrorMessage }),
  setDates: (fromProcessDate, toProcessDate) =>
    set({
      fromProcessDate: getApiFormattedDate(fromProcessDate),
      toProcessDate: getApiFormattedDate(toProcessDate),
    }),
  setView: view => set({ view }),
}));
